
import React  from 'react';
import DrawerUi from "../components/DrawerUi";
import HomeScreen from "../screens/HomeScreen";
import { createDrawerNavigator } from '@react-navigation/drawer';
import ProfileScreen from "../screens/ProfileScreen";
import RequestListScreen from "../screens/RequestListScreen";
import WalletScreen from "../screens/WalletScreen";
import FavoritPersonScreen from "../screens/FavoritPersonScreen";
import FavoritAddressScreen from "../screens/FavoritAddressScreen";
import FavoritExpertScreen from "../screens/FavoritExpertScreen";
import SettingScreen from "../screens/SettingScreen";
import CodeScreen from "../screens/CodeScreen";
import NotifictionScreen from "../screens/NotifictionScreen";
import SupportScreen from "../screens/SupportScreen";
import AboutUsScreen from "../screens/AboutUsScreen";
import RulesScreen from "../screens/RulesScreen";
import strings from "../theme/strings";
import {wp} from "../utils/responsive";



const Drawer = createDrawerNavigator();
export default function DrawerNav() {
    return <Drawer.Navigator
        headerMode='none'
        drawerPosition='right'
        drawerStyle={{width:wp(80)>300?300:wp(80)}}
        drawerContent={(props) => <DrawerUi {...props} />}
        initialRouteName="home">
        <Drawer.Screen name="home" component={HomeScreen} options={{ title: strings.asanDarman }} />
        <Drawer.Screen name="profile" component={ProfileScreen} options={{ title: strings.profile }} />
        <Drawer.Screen name="requestList" component={RequestListScreen} options={{ title: strings.orderList }} />
        <Drawer.Screen name="wallet" component={WalletScreen} options={{ title: strings.wallet }} />
        <Drawer.Screen name="favoritPerson" component={FavoritPersonScreen} options={{ title: strings.favoritPatient }} />
        <Drawer.Screen name="favoritExpert" component={FavoritExpertScreen} options={{ title: strings.favoritServant }} />
        <Drawer.Screen name="favoritAddress" component={FavoritAddressScreen} options={{ title: strings.favoritAddresses }} />
        <Drawer.Screen name="setting" component={SettingScreen} options={{ title: strings.setting }} />
        <Drawer.Screen name="code" component={CodeScreen} options={{ title: strings.adCode }} />
        <Drawer.Screen name="notifiction" component={NotifictionScreen} options={{ title: strings.messageBox }} />
        <Drawer.Screen name="support" component={SupportScreen} options={{ title: strings.offers }} />
        <Drawer.Screen name="aboutus" component={AboutUsScreen} options={{ title: strings.aboutAd }} />
        <Drawer.Screen name="rules" component={RulesScreen} options={{ title: strings.rules }} />
    </Drawer.Navigator>
}
